var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, ref, watch } from "vue";
import { useCurrentUser } from "./user";
import { useLocalStorage } from "@vueuse/core";
function hash32(value) {
    return __awaiter(this, void 0, void 0, function* () {
        const valueUtf8 = new TextEncoder().encode(value);
        const hashBuffer = yield crypto.subtle.digest("SHA-256", valueUtf8);
        return bufferToString(hashBuffer);
    });
}
function bufferToString(buffer) {
    const u8Array = new Uint8Array(buffer);
    const hashString = window.btoa(String.fromCharCode(...u8Array));
    return hashString;
}
function createSalt() {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return bufferToString(bytes);
}
const currentHash = ref(null);
let unhashedId = null;
/**
 * One way hashed ID of the current User
 */
export function useHashedUserId() {
    const { currentUser } = useCurrentUser(true);
    // salt the local store, to make a user untraceable by id across different clients
    const localStorageSalt = useLocalStorage("local-storage-salt", createSalt());
    watch(() => currentUser.value, () => {
        if (currentUser.value && !currentUser.value.isAnonymous) {
            hashUserId(currentUser.value.id + localStorageSalt.value);
        }
    }, {
        immediate: true,
    });
    function hashUserId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (unhashedId !== id) {
                unhashedId = id;
                currentHash.value = null;
                const hashed = yield hash32(id);
                currentHash.value = hashed;
            }
        });
    }
    const hashedUserId = computed(() => currentHash.value);
    return { hashedUserId };
}
